// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"eb815dd9","564":"b98154f6","742":"746468be","783":"03c65bfb","930":"00a27d1c"}[chunkId] + ".chunk.js";
};